<template>
    <div class="TopicsTopEntrance" v-loading="loading">
        <div class="TopicsTopEntrance-header">
            <div>自定义弹幕管理</div>
        </div>
        <el-form label-width="80px" :inline="true">
            <el-form-item label="状态">
                <el-select v-model="queryForm.status" placeholder="请选择状态">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="审核中" :value="0"></el-option>
                    <el-option label="审核不通过" :value="1"></el-option>
                    <el-option label="审核通过" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="关键字">
                <el-input placeholder="请输入内容" v-model="queryForm.content">
                </el-input>
            </el-form-item>
            <el-button type="primary" @click="handleQuery">
                查询
            </el-button>
            <el-button @click="handleReset">
                重置
            </el-button>
        </el-form>
        <el-table :data="tableData" border>
            <el-table-column type="index" label="序号" align="center" width="120" />
            <el-table-column prop="content" label="弹幕内容" align="center" />
            <el-table-column prop="uid" label="弹幕归属用户ID" align="center" />
            <el-table-column prop="realName" label="弹幕归属" align="center" />
            <el-table-column label="状态" align="center" inline-template>
                <div>{{ ['审核中', '审核不通过', '审核通过'][row.status] }}</div>
            </el-table-column>
            <el-table-column label="更新时间" align="center" inline-template>
                <div>{{ new Date(row.updateTime).format('yyyy-MM-dd hh:mm:ss') }}</div>
            </el-table-column>
            <el-table-column inline-template label="操作" width="200px" align="center">
                <template>
                    <el-button type="primary" size="small" @click="handlePass(row)">
                        审核通过
                    </el-button>
                    <el-button type="primary" size="small" @click="handleRejection(row)">
                        审核拒绝
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination layout="prev, pager, next, jumper" :page-size="queryForm.pageSize"
                :current-page="queryForm.pageNum" :total="tableTotal" @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            queryForm: {
                status: '',
                content: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            tableTotal: 0,
            loading: false
        }
    },
    mounted() {
        this.handleQuery()
    },
    methods: {
        // 请求分页数据分页
        handleCurrentChange(val) {
            this.queryForm.pageNum = val;
            this.handleQuery()
        },
        handlePass(row) {
            this.$confirm('是否确定审核通过？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                this.$http({
                    method: 'POST',
                    url: this.$util.domain + '/adminapi/barrage/custom/process',
                    body: JSON.stringify({
                        id: row.id,
                        status: 2
                    })
                }).then(res => {
                    if (res.body.error === 10000) {
                        this.handleQuery()
                    } else {
                        this.$util.errorMsg(res.body.message);
                    }
                })
            })
        },
        handleRejection(row) {
            this.$prompt('请输入拒绝原因', '', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(({ value }) => {
                if (!value) {
                    return
                }
                this.$http({
                    method: 'POST',
                    url: this.$util.domain + '/adminapi/barrage/custom/process',
                    body: JSON.stringify({
                        id: row.id,
                        status: 1,
                        remarks: value
                    })
                }).then(res => {
                    if (res.body.error === 10000) {
                        this.$util.successMsg('操作成功');
                        this.handleQuery()
                    } else {
                        this.$util.errorMsg(res.body.message);
                    }
                }).catch(() => {
                    this.$util.errorMsg('服务器内部错误');
                })
            })
        },
        handleQuery() {
            this.loading = true
            this.$http({
                method: 'GET',
                url: this.$util.domain + '/adminapi/barrage/custom/list',
                params: {
                    ...this.queryForm
                }
            }).then(res => {
                if (res.body.error === 10000) {
                    const { list, totalCount } = res.body.data
                    this.tableTotal = totalCount
                    if (list && list.length) {
                        this.tableData = list
                    } else {
                        this.tableData = []
                    }
                } else {
                    this.tableData = []
                    this.tableTotal = 0
                    this.$util.errorMsg(res.body.message);
                }
                this.loading = false
            }).catch(() => {
                this.tableData = []
                this.tableTotal = 0
                this.loading = false
            })
        },
        handleReset() {
            this.queryForm = {
                status: '',
                content: '',
                pageNum: 1,
                pageSize: 10
            }
            this.handleQuery()
        }
    }
}
</script>


<style scoped>
.TopicsTopEntrance-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #eee;
    font-size: 16px;
    padding: 0 10px 0 30px;
    margin: 20px 0;
}

.TopicsTopEntrance-main {
    padding: 0 10px;
}
</style>


// WEBPACK FOOTER //
// index.vue?1ea937e0